<div class="row">
    <div class="col">
        <lib-common-error [startPage]="eAppRegConstant.StartPage" [appName]="eAppRegConstant.AppName"></lib-common-error>
    </div>
</div>